import { ApiEndpointClient } from './resource-client';
const COMMUNICATION_API_PREFIX = 'communication-api/v1';
export class CommunicationsClient extends ApiEndpointClient {
    constructor(http) {
        super(http, COMMUNICATION_API_PREFIX);
    }
    patchThread = async ({ threadId, customerId, operations, }) => {
        await this.patch(`/threads/${threadId}/`, {
            query: { customer_uuid: customerId },
            json: operations,
            response: 'raw',
        });
    };
    patchMessage = async ({ threadId, messageId, customerId, operations, }) => {
        await this.patch(`/threads/${threadId}/messages/${messageId}/`, {
            query: { customer_uuid: customerId },
            json: operations,
            response: 'raw',
        });
    };
    createThread = async ({ orderId, topic, participantIds, customerId, }) => {
        return this.post('/threads/', {
            response: 'content-type-or-empty',
            query: { customer_uuid: customerId },
            json: { topic, order_uuid: orderId, participant_ids: participantIds },
        });
    };
    getThreads = async ({ orderId, userId, customerId }, options) => {
        return this.get('/threads/', {
            response: 'content-type-or-empty',
            query: { ...(orderId ? { order_uuid: orderId } : {}), ...(userId ? { user_uuid: userId } : {}), customer_uuid: customerId },
            signal: options?.signal,
        });
    };
    getThread = async ({ threadId, customerId }, options) => {
        return this.get(`/threads/${threadId}`, {
            response: 'content-type-or-empty',
            query: { customer_uuid: customerId },
            signal: options?.signal,
        });
    };
    deleteThread = async ({ threadId, customerId }) => {
        return this.delete(`/threads/${threadId}/`, {
            query: { customer_uuid: customerId },
            response: 'content-type-or-empty',
        });
    };
    createCustomerThread = async ({ orderId, topic, participantIds, customerId, }) => {
        return this.post('/threads/', {
            response: 'content-type',
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            json: { topic, order_uuid: orderId, participant_ids: participantIds },
        });
    };
    getCustomerThreads = async ({ orderId, userId, customerId } = {}, options) => {
        return this.get('/threads/', {
            response: 'content-type',
            query: {
                ...(orderId ? { order_uuid: orderId } : {}),
                ...(userId ? { user_uuid: userId } : {}),
                ...(customerId === undefined ? {} : { customer_uuid: customerId }),
            },
            signal: options?.signal,
        });
    };
    getCustomerThread = async ({ threadId, customerId }, options) => {
        return this.get(`/threads/${threadId}`, {
            response: 'content-type',
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            signal: options?.signal,
        });
    };
    deleteCustomerThread = async ({ threadId, customerId }) => {
        return this.delete(`/threads/${threadId}/`, {
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            response: 'content-type',
        });
    };
    patchCustomerThread = async ({ threadId, customerId, operations, }) => {
        return this.patch(`/threads/${threadId}/`, {
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            json: operations,
            response: 'content-type',
        });
    };
    createMessage = async ({ threadId, content, mentions, customerId, }) => {
        return this.post(`/threads/${threadId}/`, {
            response: 'content-type-or-empty',
            query: { customer_uuid: customerId },
            json: { content, mentions },
        });
    };
    deleteMessage = async ({ threadId, messageId, customerId, }) => {
        return this.delete(`/threads/${threadId}/messages/${messageId}/`, {
            query: { customer_uuid: customerId },
            response: 'content-type-or-empty',
        });
    };
    createCustomerMessage = async ({ threadId, content, mentions, customerId, }) => {
        return this.post(`/threads/${threadId}/`, {
            response: 'content-type',
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            json: { content, mentions },
        });
    };
    deleteCustomerMessage = async ({ threadId, messageId, customerId, }) => {
        return this.delete(`/threads/${threadId}/messages/${messageId}/`, {
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            response: 'content-type',
        });
    };
    patchCustomerMessage = async ({ threadId, messageId, customerId, operations, }) => {
        return this.patch(`/threads/${threadId}/messages/${messageId}/`, {
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            json: operations,
            response: 'content-type',
        });
    };
    uploadMessageImage = async ({ threadId, messageId, image, customerId, }) => {
        const body = new FormData();
        body.append('file', image);
        return this.post(`/threads/${threadId}/messages/${messageId}/images/`, {
            response: 'content-type-or-empty',
            query: { customer_uuid: customerId },
            body,
        });
    };
    uploadMessageDocument = async ({ threadId, messageId, document, customerId, }) => {
        const body = new FormData();
        body.append('file', document);
        return this.post(`/threads/${threadId}/messages/${messageId}/documents/`, {
            response: 'content-type-or-empty',
            query: { customer_uuid: customerId },
            body,
        });
    };
    uploadCustomerMessageImage = async ({ threadId, messageId, image, customerId, }) => {
        const body = new FormData();
        body.append('file', image);
        return this.post(`/threads/${threadId}/messages/${messageId}/images/`, {
            response: 'content-type',
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            body,
        });
    };
    uploadCustomerMessageDocument = async ({ threadId, messageId, document, customerId, }) => {
        const body = new FormData();
        body.append('file', document);
        return this.post(`/threads/${threadId}/messages/${messageId}/documents/`, {
            response: 'content-type',
            query: customerId === undefined ? undefined : { customer_uuid: customerId },
            body,
        });
    };
}
